export default __webpack_public_path__ + "static/media/play_arrow.c6c77a23.svg";